/* ============================================================
   LXRYWOOD Farbvergleich — Produktseiten-Block
   Vanilla JS. Keine Library, kein CDN.

   - Holzarten/Verfügbarkeit/Preise ausschließlich aus dem Varianten-JSON.
     KEINE Holzartnamen, Hex, Preise oder Variant-IDs im Code.
   - Darstellungskaskade: Bild (Template) > native Swatch > wood_map-Hex
     > neutraler Fallback-Ton (+ Editor-Hinweis).
   - Options-Sync über die Theme-Inputs (wie setMainValue), Events bubbles:true.
   - Scroll-Lock/Focus-Trap: globale Theme-Utilities.
   - „Beide Muster bestellen": EIN /cart/add mit items[], dann Cart-Drawer.

   Hinweis: Helfer (Options-Sync, Sheet) sind bewusst dupliziert statt den
   laufenden Flächenrechner umzubauen (Spec erlaubt das ausdrücklich).
   ============================================================ */
(function () {
  "use strict";

  var euroCache = {};
  function euro(currency, cents) {
    var k = currency || "EUR";
    if (!euroCache[k])
      euroCache[k] = new Intl.NumberFormat("de-DE", { style: "currency", currency: k });
    return euroCache[k].format(cents / 100);
  }

  var TONE_NEUTRAL_DEFAULT = "#c8b48f";

  function woodCss(hex) {
    return (
      "linear-gradient(90deg, rgba(0,0,0,.55) 0 4px, rgba(0,0,0,0) 4px 11px, " +
      "rgba(255,255,255,.05) 11px 12px, rgba(0,0,0,0) 12px 18px), " +
      "linear-gradient(180deg, rgba(255,255,255,.10), rgba(0,0,0,.16)), " +
      hex
    );
  }

  function initRoot(root) {
    if (root.dataset.lxryInit === "1") return;
    root.dataset.lxryInit = "1";

    var config, variants;
    try {
      config = JSON.parse(root.querySelector("[data-lxry-cmp-config]").textContent);
      variants = JSON.parse(root.querySelector("[data-lxry-cmp-variants]").textContent);
    } catch (e) {
      root.style.display = "none";
      return;
    }

    var sectionId = config.sectionId;
    var currency = config.currency || "EUR";
    var woodName = (config.optionNames && config.optionNames.wood) || "Holzart";
    var sizeName = (config.optionNames && config.optionNames.size) || "Größe";
    var order = config.optionOrder || [];
    var woodIdx = order.indexOf(woodName);
    var sizeIdx = order.indexOf(sizeName);
    var feltIdx = -1,
      feltName = null;
    for (var oi = 0; oi < order.length; oi++) {
      if (oi !== woodIdx && oi !== sizeIdx) {
        feltIdx = oi;
        feltName = order[oi];
        break;
      }
    }
    if (woodIdx < 0) {
      root.style.display = "none";
      return;
    }

    var displayMode = config.displayMode || "auto";
    var sampleVal = config.sampleOptionValue || "Muster";
    var fallbackTone = config.fallbackTone || TONE_NEUTRAL_DEFAULT;

    /* ---- wood_map parsen: Name | #hex | Helligkeit | Wärme | Raumwirkung | Passt zu | Beleg ---- */
    var woodMap = {};
    String(config.woodMap || "")
      .split("\n")
      .forEach(function (line) {
        var p = line.split("|");
        if (p[0] && p[0].trim()) {
          woodMap[p[0].trim().toLowerCase()] = {
            hex: (p[1] || "").trim(),
            bright: (p[2] || "").trim(),
            warm: (p[3] || "").trim(),
            room: (p[4] || "").trim(),
            fit: (p[5] || "").trim(),
            proof: (p[6] || "").trim(),
          };
        }
      });

    function woodMeta(name) {
      return (
        woodMap[name.toLowerCase()] ||
        { hex: "", bright: "", warm: "", room: "", fit: "", proof: "" }
      );
    }

    /* ---- pair_map parsen: schlüssel | Text (Schlüssel aus beiden Helligkeiten) ---- */
    var pairMap = {};
    String(config.pairMap || "")
      .split("\n")
      .forEach(function (line) {
        var i = line.indexOf("|");
        if (i < 0) return;
        var key = line.slice(0, i).trim().toLowerCase();
        if (key) pairMap[key] = line.slice(i + 1).trim();
      });

    // Helligkeitsschlüssel: hellerer Ton zuerst (hell < mittel < dunkel), damit
    // dunkel+hell und hell+dunkel denselben Schlüssel treffen.
    var BRIGHT_RANK = { hell: 0, mittel: 1, dunkel: 2 };
    function brightKey(ba, bb) {
      ba = (ba || "").trim().toLowerCase();
      bb = (bb || "").trim().toLowerCase();
      if (!ba || !bb) return "";
      var ra = BRIGHT_RANK[ba],
        rb = BRIGHT_RANK[bb];
      if (ra == null || rb == null) return [ba, bb].sort().join("+");
      return ra <= rb ? ba + "+" + bb : bb + "+" + ba;
    }

    // Zeile 1 (Raumwirkung): Text aus pair_map. {A} = links, {B} = rechts.
    // Fehlt der Schlüssel → leer, die Zeile entfällt still.
    function diffLine1(wa, wb, ma, mb) {
      var key = brightKey(ma.bright, mb.bright);
      if (!key) return "";
      var tmpl = pairMap[key];
      if (
        tmpl == null &&
        ma.bright &&
        mb.bright &&
        ma.bright.trim().toLowerCase() === mb.bright.trim().toLowerCase()
      ) {
        tmpl = pairMap["gleich"];
      }
      if (tmpl == null || tmpl === "") return "";
      return esc(tmpl)
        .split("{A}")
        .join("<b>" + esc(wa.name) + "</b>")
        .split("{B}")
        .join("<b>" + esc(wb.name) + "</b>");
    }

    // Zeilen 2 & 3: Vorlage segmentweise (an , . ; ! ?) füllen. Ein Segment,
    // dessen Seiten-Feld leer ist, entfällt — nicht die ganze Zeile. Getrennt
    // wird die Vorlage vor dem Einsetzen, damit Kommata IN den Feldwerten bleiben.
    function composeSides(tmpl, tokenA, valA, tokenB, valB, nameA, nameB) {
      tmpl = String(tmpl == null ? "" : tmpl);
      if (!tmpl.trim()) return "";
      valA = (valA || "").trim();
      valB = (valB || "").trim();
      var segs = tmpl.match(/[^,.;!?]*[,.;!?]+|[^,.;!?]+$/g) || [tmpl];
      var kept = [];
      segs.forEach(function (seg) {
        if (!seg.trim()) return;
        var refA = seg.indexOf(tokenA) !== -1;
        var refB = seg.indexOf(tokenB) !== -1;
        if (refA && !valA) return;
        if (refB && !valB) return;
        kept.push(
          seg
            .split(tokenA)
            .join(valA)
            .split(tokenB)
            .join(valB)
            .split("{A}")
            .join(nameA)
            .split("{B}")
            .join(nameB)
        );
      });
      var out = kept.join("").replace(/\s+/g, " ").trim();
      out = out.replace(/^[\s,;]+/, "").trim();
      out = out.replace(/\s+([,.;!?])/g, "$1");
      out = out.replace(/[,;]\s*$/, ".");
      return out.trim();
    }
    var toneWarned = {};
    function woodColor(w) {
      if (w.swatch) return w.swatch;
      var m = woodMeta(w.name);
      if (m.hex) return m.hex;
      if (config.designMode && !toneWarned[w.name]) {
        toneWarned[w.name] = true;
      }
      return fallbackTone;
    }

    /* ---- Variantenauflösung ---- */
    function findVariant(wood, sizeValue, feltValue) {
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options || [];
        if (o[woodIdx] !== wood) continue;
        if (sizeIdx >= 0 && sizeValue != null && o[sizeIdx] !== sizeValue) continue;
        if (feltIdx >= 0 && feltValue != null && o[feltIdx] !== feltValue) continue;
        return variants[i];
      }
      return null;
    }
    function woodHasAvailable(wood) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options[woodIdx] === wood && variants[i].available) return true;
      }
      return false;
    }

    /* ---- Angebotene Holzarten bestimmen ---- */
    var offered = [];
    (config.woods || []).forEach(function (w, idx) {
      if (!woodHasAvailable(w.name)) return;
      if (displayMode === "image" && !w.hasPhoto) return;
      offered.push({
        name: w.name,
        swatch: w.swatch,
        hasPhoto: !!w.hasPhoto,
        hasEve: !!w.hasEve,
        imgW: w.imgW || 0,
        imgH: w.imgH || 0,
        tmplIndex: idx,
      });
    });
    if (offered.length < 2) {
      root.style.display = "none";
      return;
    }

    /* ---- Bild-Templates einsammeln ---- */
    var templates = {};
    root.querySelectorAll("template[data-lxry-cmp-photo]").forEach(function (t) {
      var i = t.getAttribute("data-lxry-cmp-photo");
      var kind = t.getAttribute("data-kind");
      templates[i] = templates[i] || {};
      templates[i][kind] = t;
    });

    /* ---- DOM refs ---- */
    var $ = function (s) {
      return root.querySelector(s);
    };
    var sheet = $("[data-lxry-sheet]");
    var backdrop = $("[data-lxry-backdrop]");
    var openBtn = $("[data-lxry-open]");
    var closeBtn = $("[data-lxry-close]");
    var splitEl = $("[data-lxry-split]");
    var layerA = $("[data-lxry-layer-a]");
    var layerB = $("[data-lxry-layer-b]");
    var woodAEl = $("[data-lxry-wood-a]");
    var woodBEl = $("[data-lxry-wood-b]");
    var tagAEl = $("[data-lxry-tag-a]");
    var tagBEl = $("[data-lxry-tag-b]");
    var handle = $("[data-lxry-handle]");
    var duoAEl = $("[data-lxry-duo-a]");
    var duoBEl = $("[data-lxry-duo-b]");
    var nameAEl = $("[data-lxry-name-a]");
    var nameBEl = $("[data-lxry-name-b]");
    var metaAEl = $("[data-lxry-meta-a]");
    var metaBEl = $("[data-lxry-meta-b]");
    var dotsAEl = $("[data-lxry-dots-a]");
    var dotsBEl = $("[data-lxry-dots-b]");
    var pickAEl = $("[data-lxry-pick-a]");
    var pickBEl = $("[data-lxry-pick-b]");
    var d1 = $("[data-lxry-diff-1]");
    var d2 = $("[data-lxry-diff-2]");
    var d3 = $("[data-lxry-diff-3]");
    var diffP1 = d1 ? d1.closest("p") : null;
    var diffP2 = d2 ? d2.closest("p") : null;
    var diffP3 = d3 ? d3.closest("p") : null;
    var chooseAEl = $("[data-lxry-choose-a]");
    var chooseBEl = $("[data-lxry-choose-b]");
    var chooseANameEl = $("[data-lxry-choose-a-name]");
    var chooseBNameEl = $("[data-lxry-choose-b-name]");
    var sampleBtn = $("[data-lxry-sample]");
    var availEl = $("[data-lxry-avail]");
    var editorEl = $("[data-lxry-cmp-editor]");
    var lights = root.querySelectorAll("[data-lxry-light]");

    /* ---- Theme-Anbindung (Options-Sync) ---- */
    function variantSelects() {
      return document.querySelector('variant-selects[data-section="' + sectionId + '"]');
    }
    function getPageOption(optName) {
      var vs = variantSelects();
      if (!vs) return null;
      var radios = Array.prototype.slice
        .call(vs.querySelectorAll('input[type="radio"]'))
        .filter(function (r) {
          return r.name === optName;
        });
      for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i].value;
      var sels = Array.prototype.slice.call(vs.querySelectorAll("select")).filter(function (s) {
        return s.name === "options[" + optName + "]";
      });
      return sels[0] ? sels[0].value : null;
    }
    function setPageOption(optName, value) {
      var vs = variantSelects();
      if (!vs) return false;
      var radios = Array.prototype.slice
        .call(vs.querySelectorAll('input[type="radio"]'))
        .filter(function (r) {
          return r.name === optName;
        });
      if (radios.length) {
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].value === value) {
            if (!radios[i].checked) {
              radios[i].checked = true;
              radios[i].dispatchEvent(new Event("input", { bubbles: true }));
              radios[i].dispatchEvent(new Event("change", { bubbles: true }));
            }
            flashControl(radios[i]);
            return true;
          }
        }
        return false;
      }
      var sels = Array.prototype.slice.call(vs.querySelectorAll("select")).filter(function (s) {
        return s.name === "options[" + optName + "]";
      });
      if (sels[0]) {
        if (sels[0].value !== value) {
          sels[0].value = value;
          sels[0].dispatchEvent(new Event("input", { bubbles: true }));
          sels[0].dispatchEvent(new Event("change", { bubbles: true }));
        }
        flashControl(sels[0]);
        return true;
      }
      return false;
    }
    function flashControl(input) {
      var el = input;
      if (input.id) {
        var lbl = root.ownerDocument.querySelector('label[for="' + input.id + '"]');
        if (lbl) el = lbl;
      }
      el.classList.add("lxry-cmp-flash");
      setTimeout(function () {
        el.classList.remove("lxry-cmp-flash");
      }, 1500);
    }

    /* ---- Zustand ---- */
    var A = 0,
      B = 1,
      pos = Math.max(6, Math.min(94, config.splitStart || 50)),
      light = "day",
      lastActive = "a";
    var sideSig = { a: "", b: "" };
    var diffSig = null;

    function curSize() {
      return sizeIdx >= 0 ? getPageOption(sizeName) : null;
    }
    function curFelt() {
      return feltIdx >= 0 ? getPageOption(feltName) : null;
    }

    /* ---- Split-Ebene bauen (nur bei Wechsel neu klonen → kein Re-Load) ---- */
    function buildSide(woodEl, w, useEve) {
      var sig = w.tmplIndex + "|" + (useEve && w.hasEve ? "eve" : "day") + "|" + displayMode;
      return { sig: sig, apply: function () {
        woodEl.style.background = woodCss(woodColor(w));
        // vorhandenes Bild entfernen
        var old = woodEl.querySelector(".lxry-cmp__img");
        if (old) old.remove();
        if (displayMode !== "color" && w.hasPhoto && templates[w.tmplIndex]) {
          var kind = useEve && w.hasEve ? "eve" : "day";
          var tmpl = templates[w.tmplIndex][kind] || templates[w.tmplIndex]["day"];
          if (tmpl && "content" in tmpl) {
            woodEl.appendChild(tmpl.content.cloneNode(true));
            // data-srcset → srcset promoten (Theme-Lazy-Modus greift bei geklonten Nodes nicht)
            woodEl.querySelectorAll("img[data-srcset]").forEach(function (img) {
              if (img.dataset.srcset) img.setAttribute("srcset", img.dataset.srcset);
              if (img.dataset.src) img.setAttribute("src", img.dataset.src);
              img.removeAttribute("data-srcset");
            });
          }
        }
      } };
    }

    /* ---- Diff-Block in EINEM Durchgang schreiben ----
       Die Live-Region (aria-live="polite") darf beim Seitenwechsel nicht drei-
       mal nacheinander vorgelesen werden. Deshalb: alle drei Zeilen synchron in
       einem Rutsch setzen und bei unveränderter Signatur gar nicht anfassen. */
    function writeDiff(html1, text2, text3) {
      var sig = html1 + "" + text2 + "" + text3;
      if (sig === diffSig) return; // keine echte Änderung → keine erneute Ansage
      diffSig = sig;
      if (d1) {
        d1.innerHTML = html1;
        if (diffP1) diffP1.hidden = !html1;
      }
      if (d2) {
        d2.textContent = text2;
        if (diffP2) diffP2.hidden = !text2;
      }
      if (d3) {
        d3.textContent = text3;
        if (diffP3) diffP3.hidden = !text3;
      }
    }

    /* ---- Render ---- */
    function render() {
      var wa = offered[A],
        wb = offered[B];
      var eveMode = light === "eve";
      var bothEvePhotos =
        eveMode &&
        displayMode !== "color" &&
        wa.hasPhoto && wa.hasEve && wb.hasPhoto && wb.hasEve;
      var useEve = bothEvePhotos;
      var filterEve = eveMode && !bothEvePhotos;

      // Ebenen nur bei Signaturänderung neu aufbauen (verhindert Bild-Reload)
      var sa = buildSide(woodAEl, wa, useEve);
      if (sa.sig !== sideSig.a) {
        sa.apply();
        sideSig.a = sa.sig;
      }
      var sb = buildSide(woodBEl, wb, useEve);
      if (sb.sig !== sideSig.b) {
        sb.apply();
        sideSig.b = sb.sig;
      }

      splitEl.classList.toggle("is-eve", filterEve);
      layerB.style.clipPath = "inset(0 0 0 " + pos + "%)";
      handle.style.left = pos + "%";
      handle.setAttribute("aria-valuenow", Math.round(pos));

      tagAEl.textContent = wa.name;
      tagBEl.textContent = wb.name;
      nameAEl.textContent = wa.name;
      nameBEl.textContent = wb.name;
      chooseANameEl.textContent = wa.name;
      chooseBNameEl.textContent = wb.name;
      duoAEl.style.background = woodColor(wa);
      duoBEl.style.background = woodColor(wb);

      var ma = woodMeta(wa.name),
        mb = woodMeta(wb.name);
      metaAEl.textContent = [ma.bright, ma.warm].filter(Boolean).join(" · ");
      metaBEl.textContent = [mb.bright, mb.warm].filter(Boolean).join(" · ");

      // Dots aktiv
      dotsAEl.querySelectorAll(".lxry-cmp__pd").forEach(function (d, i) {
        d.classList.toggle("is-on", i === A);
        d.setAttribute("aria-checked", i === A ? "true" : "false");
      });
      dotsBEl.querySelectorAll(".lxry-cmp__pd").forEach(function (d, i) {
        d.classList.toggle("is-on", i === B);
        d.setAttribute("aria-checked", i === B ? "true" : "false");
      });
      pickAEl.classList.toggle("lxry-cmp__pick--act", lastActive === "a");
      pickBEl.classList.toggle("lxry-cmp__pick--act", lastActive === "b");

      // Diff — Zeilen erst berechnen, dann in EINEM Durchgang schreiben.
      var html1 = diffLine1(wa, wb, ma, mb);
      var text2 = composeSides(
        config.line2Template,
        "{A_fit}",
        ma.fit,
        "{B_fit}",
        mb.fit,
        wa.name,
        wb.name
      );
      var proofPart = composeSides(
        config.line3Template,
        "{A_proof}",
        ma.proof,
        "{B_proof}",
        mb.proof,
        wa.name,
        wb.name
      );
      var text3 = [proofPart, priceSentence(wa.name, wb.name)]
        .filter(Boolean)
        .join(" ");
      writeDiff(html1, text2, text3);

      updateChoose(wa, wb);
      updateSample(wa, wb);
    }

    function priceSentence(a, b) {
      var s = curSize(),
        f = curFelt();
      var va = findVariant(a, s, f),
        vb = findVariant(b, s, f);
      if (!va || !vb) return "Preis je nach Größe und Filzfarbe — beide Töne im selben Rahmen.";
      if (va.price === vb.price) return "Beide Töne kosten gleich viel — die Entscheidung ist rein optisch.";
      var diff = Math.abs(va.price - vb.price);
      var more = va.price > vb.price ? a : b;
      var less = va.price > vb.price ? b : a;
      return more + " kostet " + euro(currency, diff) + " mehr als " + less + ".";
    }

    function updateChoose(wa, wb) {
      var s = curSize(),
        f = curFelt();
      var va = findVariant(wa.name, s, f),
        vb = findVariant(wb.name, s, f);
      var okA = va && va.available;
      var okB = vb && vb.available;
      chooseAEl.disabled = !okA;
      chooseBEl.disabled = !okB;
      if (!okA || !okB) {
        var which = !okA ? wa.name : wb.name;
        availEl.textContent =
          "„" + which + "“ ist mit der aktuellen Größe/Filzfarbe nicht verfügbar.";
        availEl.classList.remove("lxry-cmp__hidden");
      } else {
        availEl.classList.add("lxry-cmp__hidden");
        availEl.textContent = "";
      }
    }

    function musterVariant(woodv) {
      var f = curFelt();
      var v = findVariant(woodv, sampleVal, f);
      return v && v.available ? v : null;
    }
    function updateSample(wa, wb) {
      if (!sampleBtn) return;
      var va = musterVariant(wa.name),
        vb = musterVariant(wb.name);
      if (va && vb && va.id !== vb.id) sampleBtn.classList.remove("lxry-cmp__hidden");
      else sampleBtn.classList.add("lxry-cmp__hidden");
    }

    function esc(s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
      });
    }

    /* ---- Dots bauen ---- */
    function buildDots(wrap, side) {
      offered.forEach(function (w, i) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "lxry-cmp__pd";
        b.setAttribute("role", "radio");
        b.setAttribute("aria-checked", "false");
        b.setAttribute("aria-label", w.name + ", " + (side === "a" ? "linke Seite" : "rechte Seite"));
        b.style.setProperty("--_pd", woodColor(w));
        b.addEventListener("click", function () {
          if (side === "a") {
            if (i === B) B = A;
            A = i;
            lastActive = "a";
          } else {
            if (i === A) A = B;
            B = i;
            lastActive = "b";
          }
          render();
        });
        wrap.appendChild(b);
      });
    }
    buildDots(dotsAEl, "a");
    buildDots(dotsBEl, "b");

    /* ---- Licht ---- */
    lights.forEach(function (b) {
      b.addEventListener("click", function () {
        lights.forEach(function (x) {
          x.classList.remove("is-on");
          x.setAttribute("aria-pressed", "false");
        });
        b.classList.add("is-on");
        b.setAttribute("aria-pressed", "true");
        light = b.getAttribute("data-lxry-light");
        render();
      });
    });

    /* ---- Trennlinie: Pointer ---- */
    var dragging = false;
    function moveFromEvent(e) {
      var r = splitEl.getBoundingClientRect();
      var x = (e.clientX != null ? e.clientX : 0) - r.left;
      pos = Math.max(6, Math.min(94, (x / r.width) * 100));
      layerB.style.clipPath = "inset(0 0 0 " + pos + "%)";
      handle.style.left = pos + "%";
      handle.setAttribute("aria-valuenow", Math.round(pos));
    }
    splitEl.addEventListener("pointerdown", function (e) {
      dragging = true;
      try {
        splitEl.setPointerCapture(e.pointerId);
      } catch (err) {}
      moveFromEvent(e);
    });
    splitEl.addEventListener("pointermove", function (e) {
      if (dragging) moveFromEvent(e);
    });
    splitEl.addEventListener("pointerup", function () {
      dragging = false;
    });
    splitEl.addEventListener("pointercancel", function () {
      dragging = false;
    });

    /* ---- Trennlinie: Tastatur ---- */
    handle.addEventListener("keydown", function (e) {
      var k = e.key;
      var np = pos;
      if (k === "ArrowLeft" || k === "ArrowDown") np = pos - 2;
      else if (k === "ArrowRight" || k === "ArrowUp") np = pos + 2;
      else if (k === "Home") np = 6;
      else if (k === "End") np = 94;
      else return;
      e.preventDefault();
      pos = Math.max(6, Math.min(94, np));
      layerB.style.clipPath = "inset(0 0 0 " + pos + "%)";
      handle.style.left = pos + "%";
      handle.setAttribute("aria-valuenow", Math.round(pos));
    });

    /* ---- Sheet öffnen/schließen ---- */
    var lastFocus = null,
      scrollY = 0,
      opened = false;
    function lockScroll() {
      if (typeof window.disablePageScroll === "function") window.disablePageScroll();
      else {
        scrollY = window.pageYOffset || 0;
        document.body.style.top = -scrollY + "px";
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
      }
    }
    function unlockScroll() {
      if (typeof window.enablePageScroll === "function") window.enablePageScroll();
      else {
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";
        window.scrollTo(0, scrollY);
      }
    }
    function openSheet() {
      lastFocus = document.activeElement;
      // Vorauswahl: links aktuelle Seiten-Holzart, rechts nächste verfügbare
      var pageWood = getPageOption(woodName);
      var ai = 0;
      for (var i = 0; i < offered.length; i++) if (offered[i].name === pageWood) ai = i;
      A = ai;
      B = ai === 0 ? 1 : 0;
      lastActive = "a";
      backdrop.hidden = false;
      sheet.hidden = false;
      lockScroll();
      requestAnimationFrame(function () {
        backdrop.classList.add("is-open");
        sheet.classList.add("is-open");
        sideSig.a = "";
        sideSig.b = "";
        render();
        if (!opened) {
          opened = true;
          if (config.designMode) buildEditorNote();
        }
        if (typeof window.trapFocus === "function") window.trapFocus(sheet, closeBtn);
        else if (closeBtn) closeBtn.focus();
      });
    }
    function closeSheet() {
      backdrop.classList.remove("is-open");
      sheet.classList.remove("is-open");
      unlockScroll();
      if (typeof window.removeTrapFocus === "function") window.removeTrapFocus(lastFocus || openBtn);
      else if (lastFocus) lastFocus.focus();
      setTimeout(function () {
        sheet.hidden = true;
        backdrop.hidden = true;
      }, 400);
    }

    openBtn.addEventListener("click", openSheet);
    closeBtn.addEventListener("click", closeSheet);
    backdrop.addEventListener("click", closeSheet);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && sheet.classList.contains("is-open")) closeSheet();
    });

    /* ---- Auswahl übernehmen ---- */
    chooseAEl.addEventListener("click", function () {
      if (chooseAEl.disabled) return;
      setPageOption(woodName, offered[A].name);
      closeSheet();
    });
    chooseBEl.addEventListener("click", function () {
      if (chooseBEl.disabled) return;
      setPageOption(woodName, offered[B].name);
      closeSheet();
    });

    /* ---- Beide Muster bestellen (ein /cart/add) ---- */
    if (sampleBtn) {
      sampleBtn.addEventListener("click", function () {
        var va = musterVariant(offered[A].name),
          vb = musterVariant(offered[B].name);
        if (!va || !vb) {
          showAvail("Ein Muster ist derzeit nicht verfügbar.");
          return;
        }
        addBothSamples(va.id, vb.id);
      });
    }
    function showAvail(msg) {
      if (!availEl) return;
      availEl.textContent = msg;
      availEl.classList.remove("lxry-cmp__hidden");
    }
    function addBothSamples(idA, idB) {
      var drawer = document.getElementById("Cart-Drawer");
      var active = drawer && !drawer.hasAttribute("data-status-silence");
      var sections = [
        { id: "Cart-Icon-Bubble", section: "cart-icon-bubble", selector: ".shopify-section" },
      ];
      if (active)
        sections.push({ id: "Cart-Drawer", section: drawer.dataset.section, selector: "#Cart-Drawer-Details" });

      var body = JSON.stringify({
        items: [
          { id: idA, quantity: 1 },
          { id: idB, quantity: 1 },
        ],
        sections: sections.map(function (s) {
          return s.section;
        }),
        sections_url: window.location.pathname,
      });
      var cfg =
        typeof window.fetchConfig === "function"
          ? window.fetchConfig("javascript")
          : { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/javascript" } };
      var routes = window.routes || {};
      if (!routes.cart_add_url) {
        showAvail("Warenkorb nicht verfügbar.");
        return;
      }
      sampleBtn.disabled = true;
      fetch(routes.cart_add_url, Object.assign({}, cfg, { body: body }))
        .then(function (r) {
          return r.json();
        })
        .then(function (res) {
          sampleBtn.disabled = false;
          if (res && res.status) {
            showAvail(res.description || res.message || "Konnte nicht hinzugefügt werden.");
            return;
          }
          if (window.SectionDynamicUpdate && window.SectionDynamicUpdate.updateSections)
            window.SectionDynamicUpdate.updateSections(sections, res.sections);
          if (typeof window.publish === "function" && window.PUB_SUB_EVENTS)
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: "lxry-cmp", cartData: res });
          closeSheet();
          if (active) drawer.show(sampleBtn);
          else window.location = routes.cart_url;
        })
        .catch(function () {
          sampleBtn.disabled = false;
          showAvail("Netzwerkfehler. Bitte erneut versuchen.");
        });
    }

    /* ---- Seite → Sheet: Holzart/Filz-Wechsel spiegeln ---- */
    var vs = variantSelects();
    if (vs) {
      vs.addEventListener("change", function () {
        placeTrigger(); // erneut sicherstellen, falls das Theme die Gruppe neu rendert
        if (!sheet.classList.contains("is-open")) return;
        var pw = getPageOption(woodName);
        for (var i = 0; i < offered.length; i++) {
          if (offered[i].name === pw && i !== B) {
            A = i;
            lastActive = "a";
            break;
          }
        }
        render();
      });
    }

    /* ---- Editor-Hinweise ---- */
    function buildEditorNote() {
      if (!editorEl) return;
      var msgs = [];
      var noRep = offered
        .filter(function (w) {
          return !w.swatch && !woodMeta(w.name).hex && !w.hasPhoto;
        })
        .map(function (w) {
          return w.name;
        });
      if (noRep.length) msgs.push("Ohne Darstellung (neutraler Ton): " + noRep.join(", ") + ".");
      var ratios = {};
      offered.forEach(function (w) {
        if (w.hasPhoto && w.imgW && w.imgH) ratios[(w.imgW / w.imgH).toFixed(2)] = true;
      });
      if (Object.keys(ratios).length > 1)
        msgs.push("Bilder haben unterschiedliche Seitenverhältnisse — für einen fairen Vergleich gleichen Ausschnitt verwenden.");
      if (msgs.length) {
        editorEl.textContent = "Hinweis (nur Editor): " + msgs.join(" ");
        editorEl.classList.remove("lxry-cmp__hidden");
      }
    }

    /* ---- Trigger-Position: hinter die Holzart-Optionsgruppe schieben ---- */
    function woodControl() {
      var vs = variantSelects();
      if (!vs) return null;
      var radios = Array.prototype.slice
        .call(vs.querySelectorAll('input[type="radio"]'))
        .filter(function (r) {
          return r.name === woodName;
        });
      if (radios[0]) return radios[0];
      var sels = Array.prototype.slice.call(vs.querySelectorAll("select")).filter(function (s) {
        return s.name === "options[" + woodName + "]";
      });
      return sels[0] || null;
    }
    function placeTrigger() {
      if ((config.triggerPosition || "default") !== "after_wood") return;
      var ctrl = woodControl();
      if (!ctrl) return;
      var group = ctrl.closest(".product-form-input");
      if (!group || !group.parentNode) return;
      if (group.nextSibling === openBtn) return; // schon korrekt platziert
      openBtn.classList.add("lxry-cmp__trigger--inline");
      group.parentNode.insertBefore(openBtn, group.nextSibling);
    }

    /* ---- Init (ohne Sheet zu öffnen): Trigger-Duo färben + platzieren ---- */
    duoAEl.style.background = woodColor(offered[0]);
    duoBEl.style.background = woodColor(offered[1]);
    placeTrigger();
  }

  function initAll() {
    document.querySelectorAll("[data-lxry-cmp]").forEach(function (root) {
      initRoot(root);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();
})();
